import { render, staticRenderFns } from "./DocumentsAndSignatures.vue?vue&type=template&id=543412a8&scoped=true"
import script from "./DocumentsAndSignatures.vue?vue&type=script&lang=js"
export * from "./DocumentsAndSignatures.vue?vue&type=script&lang=js"
import style0 from "./DocumentsAndSignatures.vue?vue&type=style&index=0&id=543412a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543412a8",
  null
  
)

export default component.exports